import { CHAT_OPEN, CHAT_CLOSE, CHAT_TOGGLE } from 'store/actions/Chat/types'

const initialState = {
  isOpen: false
}

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHAT_OPEN:
      return {
        ...state,
        isOpen: true
      }
    case CHAT_CLOSE:
      return {
        ...state,
        isOpen: false
      }
    case CHAT_TOGGLE:
      return {
        ...state,
        isOpen: !state.isOpen
      }
    default:
      return state
  }
}

export default chatReducer